module.exports = __webpack_public_path__ + "media/images/favicon/favicon-16-f1d1a1323b1d1d8f5c76cf0887491058.png";